import {
  UPDATE_IMAGE_VIEWER_DETAILS,
  GET_IMAGE_VIEWER_LIST,
  CLOSE_IMAGE_VIEWER,
  FILL_INITIAL_DATA_IMAGE_VIEWER,
} from "./ImageViewerType";
import callApi from "util/apiCaller";


export const updateImageViewerDetails = (data) => {
  return { type: UPDATE_IMAGE_VIEWER_DETAILS, payload: data };
};

export const getImageViewerList = (date, limit = 20) => async (
  dispatch,
  getState,
) => {
  const organizationId = getState().app?.organizations[0]?.organization_id.id;
  const activeConversationId = getState().thread?.activeConversation?.id;

  try {
    if (organizationId && activeConversationId) {
      const response = await callApi(
        `v1/organizations/${organizationId}/chats/${activeConversationId}/media/?limit=${limit}&offset=1&sinceUtc=${new Date(
          date,
        ).toISOString()}`,
      );

      const formattedData = response?.results.data.map((item) => {
        return {
          id: item.id,
          src: item.media_url,
          messageType:
            item.chat_message_type === "CustomerMessage" ? "Received" : "Sent",
          date: item.received_at_utc,
          name: item.media_file_name,
          contentType: item.message_content_type,
        };
      });

      dispatch({
        type: GET_IMAGE_VIEWER_LIST,
        payload: { data: formattedData },
      });
    }
  } catch (error) {}
};

export const closeImageViewer = () => {
  return { type: CLOSE_IMAGE_VIEWER };
};

export const fillInitialDataImageViewer = (data, activeConversationId) => {
  return {
    type: FILL_INITIAL_DATA_IMAGE_VIEWER,
    payload: { data, activeConversationId },
  };
};
